import { Camera, MessageCircle, type LucideIcon } from 'lucide-react';
import { cn } from './lib/utils';
import type { Flavor } from './types';

type IconProps = {
  icon: LucideIcon;
  size?: 'sm' | 'md' | 'lg';
  label?: string;
  className?: string;
};

const sizes = { sm: 'size-(--icon-sm)', md: 'size-(--icon-md)', lg: 'size-(--icon-lg)' };

// A lucide icon at the icon tokens, stroke 2 and 1.75 at 16 px (design system §3.3). Decorative unless it has a
// label, then it is an image named by it.
export function Icon({ icon: Glyph, size = 'md', label, className }: IconProps) {
  return (
    <Glyph
      className={cn(sizes[size], className)}
      strokeWidth={size === 'sm' ? 1.75 : 2}
      {...(label === undefined ? { 'aria-hidden': true } : { role: 'img', 'aria-label': label })}
    />
  );
}

// Neutral lucide glyphs for the channels, never the brands' logos (design system §7).
export const channelIcons: Record<Flavor, LucideIcon> = {
  whatsapp: MessageCircle,
  instagram: Camera,
};
